export function bookingMonitoringMode(params, technical) {
  // Historical SAFE_TEST records remain visible to authorized IT users without
  // being relabelled as LIVE or counted as production revenue.
  return params.get('mode') || (technical ? 'ALL' : 'LIVE');
}
